import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';

@Component({
  selector: 'app-siod-add',
  templateUrl: './siod-add.component.html',
  styleUrls: ['./siod-add.component.scss']
})
export class SiodAddComponent implements OnInit {

  constructor(private router: Router) { }

  ngOnInit(): void {
  }
}
